import React from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { generateChartColor, fold } from "../../../../helpers/chartHelper";
import { adjustContentHeight } from "../../../../helpers/viewPortHelper";
import { templateHelper } from "../../../../cms/areas/template/helpers/templateHelper";
import wordCloud from "highcharts/modules/wordcloud";

wordCloud(Highcharts);

Highcharts.seriesTypes.wordcloud.prototype.deriveFontSize = function (relativeWeight) {
  var maxFontSize = 25;
  var minFontSize = relativeWeight < 15 ? 15 : relativeWeight;
  // Will return a fontSize between 0px and 25px.
  return Math.floor(maxFontSize * relativeWeight);
};

export const WordCloud = ({ data, questionName, categories, template, size, autoFit = false, showPrecentage = true, presentationOrder }) => {
  let colors = [];
  if (template.chart.colors) {
    colors = [template.chart.colors.color1, template.chart.colors.color2, template.chart.colors.color3, template.chart.colors.color4, template.chart.colors.color5];
  }

  const distinctAnswers = data.reduce((acc, text) => {
    const key = text.toLowerCase()?.replace("\n", "");
    if (acc[key]) {
      acc[key].recurrencies = acc[key].recurrencies + 1;
      return acc;
    }
    acc[key] = {
      originalText: text,
      recurrencies: 1,
    };
    return acc;
  }, {});

  const words = Highcharts.reduce(
    Object.entries(distinctAnswers),
    function (arr, [text, { originalText, recurrencies }]) {
      const scalingFactor = 90 / (Math.max(...Object.entries(distinctAnswers).map(([_, { recurrencies }]) => recurrencies)) || 1);
      const weight = Math.round(scalingFactor * recurrencies) + 20;
      return [...arr, { weight, name: originalText }];
    },
    []
  );
  const options = {
    chart: {
      backgroundColor: "transparent",
      height: window.innerHeight * 0.95,
    },
    title: {
      text: questionName,
      style: {
        fontSize: autoFit ? "2vh" : template.title.fontSize,
        fontFamily: template.title.fontFamily,
        color: template.title.color,
        textAlign: autoFit ? "left" : "center",
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      wordCloud: {
        minFontSize: 15,
      },
    },
    series: [
      {
        type: "wordcloud",
        data: words,
        wordCloud: {
          minFontSize: 15,
        },
        colors: colors,
        rotation: {
          from: 0,
          to: 0,
          orientations: 5,
        },
      },
    ],
  };
  return (
    <div className="word-cloud">
      <HighchartsReact highcharts={Highcharts} options={options} />;
    </div>
  );
};
